import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { EventScreenTemplate } from '@/shared/ui/eventScreenTemplate'
import { lang } from '@/shared/constants/lang'

import { goToMain, goToTasks } from '@/app/routing/events'
import { InfoBlock } from '@/shared/ui/infoBlock'
import { darkTheme } from '@/shared/styles/theme/dark'
import { $newsQuery } from '@/entities/navigation/store'
import { useBackButton } from '@/shared/hooks/useBackButton'
import TasksList from '@/features/tasksList'
import { mockSteamOnTasks } from '@/shared/constants/mock'
import WebApp from '@twa-dev/sdk'

export const NewsView = () => {
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.news
  const variant = useUnit($newsQuery)
  const prefix = userLang === 'en' ? 'en' : 'ru'

  useBackButton({})

  if (variant === 'loyalty') {
    return (
      <EventScreenTemplate
        bgImage={`https://storage.yandexcloud.net/gamed/news/${prefix}loyaltybg.webp`}
        heading={text.loyalty.heading}
        description={text.loyalty.description}
        content={<br />}
        notation={text.loyalty.notation}
        onClick={() => {
          WebApp.HapticFeedback.impactOccurred('soft')
          WebApp.openTelegramLink('https://t.me/tapps/center?startapp=loyalty-push')
        }}
        bgImageStyles={{ position: 'relative', maxWidth: '100%', top: '0%' }}
        btnText={lang[userLang].pages.btnTexts.towardsRewards}
        contentBgColor="rgba(176, 177, 184, 0.12)"
        contentStyles={{
          marginTop: '25px',
        }}
      />
    )
  }
  if (variant === 'primary') {
    return (
      <EventScreenTemplate
        bgImage="assets/lootBoxRelated/boxes/14Box.webp"
        heading={text.steamDeck.heading}
        description={text.steamDeck.description}
        notation={text.steamDeck.notation}
        onClick={() => goToMain()}
        content={
          <InfoBlock
            width="100%"
            title={text.steamDeck.content.heading}
            description={text.steamDeck.content.description}
            icon="steamDeckNews"
            iconWidth={40}
            borderRadius="8px"
            bgColor={darkTheme.colors.button.primary.disabled}
          />
        }
        bgImageStyles={{ position: 'relative', maxWidth: '320px', top: '1%' }}
        // glowStyles={{ width: '100%', bottom: '75%', background: 'rgb(255, 236, 151)' }}
        btnText={lang[userLang].pages.btnTexts.time}
        contentBgColor="rgba(176, 177, 184, 0.12)"
      />
    )
  }

  if (variant === 'secondary') {
    return (
      <EventScreenTemplate
        bgImage="assets/lootBoxRelated/rewardsPreview/cargocase/300000.png"
        heading={text.cargo.heading}
        description={text.cargo.description}
        notation={text.cargo.notation}
        onClick={() => goToMain()}
        backdrop={true}
        content={
          <InfoBlock
            width="100%"
            title={text.cargo.content.heading}
            description={text.cargo.content.description}
            icon="tggift"
            iconWidth={40}
            borderRadius="8px"
            bgColor={darkTheme.colors.button.primary.disabled}
          />
        }
        bgImageStyles={{ position: 'relative', width: '80%', top: '-5%' }}
        btnText={lang[userLang].pages.btnTexts.time}
        contentBgColor="rgba(176, 177, 184, 0.12)"
      />
    )
  }
  if (variant === 'tertiary') {
    return (
      <EventScreenTemplate
        bgImage="/assets/backgrounds/farcanaGameplay.webp"
        heading={text.playtest.heading}
        description={text.playtest.description}
        contentStyles={{ bottom: '0%', marginBottom: '64px' }}
        // notation={text.playtest.notation}
        btnText={lang[userLang].pages.btnTexts.towardsVictories}
        contentBgColor="rgba(176, 177, 184, 0.12)"
        onClick={() => goToMain()}
        secondImageSrc="/assets/backgrounds/gabbyChopped.webp"
        secondImageStyles={{
          position: 'absolute',
          zIndex: '2',
          width: '100%',
          left: '20%',
          top: '-10%',
          maxWidth: '390px',
        }}
        thirdImageSrc="/assets/webp/icons/farcana.webp"
        thirdImageStyles={{
          position: 'absolute',
          width: '40%',
          zIndex: 2,
          left: '10%',
          top: '5%',
        }}
        bgImageStyles={{
          position: 'absolute',
          zIndex: 0,
          left: '-92px',
          width: '200%',
          top: '0px',

          filter: 'brightness(50%)',
        }}
      />
    )
  }
  // if (variant === 'cityholder') {
  //   return (
  //     <EventScreenTemplate
  //       bgImage="/assets/backgrounds/cityholderbg.webp"
  //       bgImageStyles={{ position: 'absolute', width: '100%', top: '0px', left: '0px' }}
  //       heading={text.cityholder.heading}
  //       description={''}
  //       notation={text.cityholder.notation(handleOpenCityHolder)}
  //       btnText={lang[userLang].pages.btnTexts.time}
  //       contentBgColor="rgba(176, 177, 184, 0.12)"
  //       onClick={() => goToMain()}
  //     />
  //   )
  // }
  if (variant === 'gigi') {
    return (
      <EventScreenTemplate
        bgImage="/assets/backgrounds/giginewsbg.webp"
        bgImageStyles={{ position: 'absolute', width: '100%', top: '0px', left: '0px' }}
        heading={text.gigi.heading}
        description={''}
        notation={text.gigi.notation}
        btnText={lang[userLang].pages.btnTexts.time}
        contentBgColor="rgba(176, 177, 184, 0.12)"
        onClick={() => goToMain()}
      />
    )
  }
  if (variant === 'egs') {
    return (
      <EventScreenTemplate
        bgImage="/assets/backgrounds/egsnewsbg.webp"
        bgImageStyles={{ position: 'absolute', width: '100%', top: '0px', left: '0px' }}
        heading={text.egs.heading}
        description={''}
        notation={text.egs.notation}
        btnText={lang[userLang].pages.btnTexts.time}
        contentBgColor="rgba(176, 177, 184, 0.12)"
        onClick={() => goToMain()}
      />
    )
  }

  if (variant === 'steamOn') {
    return (
      <EventScreenTemplate
        bgImage="/assets/backgrounds/huievent3.webp"
        bgImageStyles={{ width: '158%', top: '-1%' }}
        heading={text.steamOn.heading}
        content={
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => goToTasks({ tab: 1 })}
          >
            <div style={{ margin: '12px 0px', pointerEvents: 'none' }}>
              <TasksList
                tasksList={mockSteamOnTasks}
                isNews
              />
            </div>
          </div>
        }
        description={text.steamOn.description}
        notation={text.steamOn.notation}
        contentBgColor="rgba(176, 177, 184, 0.12)"
        btnText={lang[userLang].pages.btnTexts.participate}
        onClick={() => goToTasks({ tab: 1 })}
      />
    )
  }

  if (variant === 'ps5') {
    return (
      <EventScreenTemplate
        bgImage="assets/backgrounds/playstationWithPack.webp"
        heading={text.ps5.heading}
        description={text.ps5.description}
        notation={text.ps5.notation}
        onClick={() => goToMain()}
        content={
          <InfoBlock
            width="100%"
            title={text.ps5.content.heading}
            description={text.ps5.content.description}
            icon="steamDeckNews"
            iconWidth={40}
            borderRadius="8px"
            bgColor={darkTheme.colors.button.primary.disabled}
          />
        }
        bgImageStyles={{ position: 'relative', maxWidth: '320px', top: '-5%' }}
        // glowStyles={{ width: '100%', bottom: '75%', background: 'rgb(255, 236, 151)' }}
        btnText={lang[userLang].pages.btnTexts.time}
        contentBgColor="rgba(176, 177, 184, 0.12)"
      />
    )
  }
  if (variant === 'telegramApps') {
    return (
      <EventScreenTemplate
        bgImage="assets/lootBoxRelated/boxes/17Box.webp"
        heading={text.telegramApps.heading}
        description={text.telegramApps.description}
        onClick={() => WebApp.openTelegramLink('https://t.me/tapps_bot/center?startapp=app_gamed')}
        bgImageStyles={{ position: 'relative', maxWidth: '320px', top: '-5%' }}
        btnText={lang[userLang].pages.btnTexts.voteNow}
        contentBgColor="rgba(176, 177, 184, 0.12)"
      />
    )
  }

  return <></>
}
